export default __webpack_public_path__ + "static/media/DesktopImageItem1.3640ca0f.png";